import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default () => {
  const _tabs = document.querySelector('.section-about-us .tabs')?.getAttribute('data-items');
  if (_tabs) {
    const tabs = _tabs.split('|');
    new Swiper('.swiper-home-about-us', {
      modules: [Pagination],
      pagination: {
        el: '.section-about-us .tabs',
        clickable: true,
        renderBullet: function (index, className) {
          return `<button class="tab-item ${className}">${tabs[index]}</button>`
        },
      },
    });
  }

  new Swiper('.home-header-slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: true,
    navigation: {
      nextEl: '.home-header-slider-button-next',
      prevEl: '.home-header-slider-button-prev',
    },
    pagination: {
      el: '.home-header-slider-pagination',
      clickable: true,
    },
  });

  new Swiper('.swiper-events', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    freeMode: true,
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  new Swiper('.swiper-partners', {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    freeMode: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
      },
    },
  });
}
